var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.gouot}}),_c('span',[_vm._v("车辆信息")]),_c('span',{on:{"click":_vm.islogout}},[_vm._v("退出")])]),_c('div',{staticClass:"component"},[_c('div'),_c('div',[_c('DrivingLicense')],1)]),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }